import { render, staticRenderFns } from "./GameIds.vue?vue&type=template&id=3bcc81bd"
import script from "./GameIds.vue?vue&type=script&lang=js"
export * from "./GameIds.vue?vue&type=script&lang=js"
import style0 from "./GameIds.vue?vue&type=style&index=0&id=3bcc81bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports